<template>
  <div class="time">
    <!-- 删除消息 -->
    <div v-if="del" class="time-item">{{ isMe ? '你' : message.to }}删除了一条消息</div>
    <!-- 撤销了消息 只有文本消息才能重新编辑-->
    <div v-else-if="revoke" class="time-item">
      {{ isMe ? '你' : message.to }}撤销了一条消息
      <span v-if="showReeditBtn" class="text" @click="onEditor">重新编辑</span>
    </div>
    <!-- 自定义 -->
    <div v-else-if="isMe && customTxt" class="time-item">
      <div class="content">
        <span class="default-text">{{ messageContext.text }}</span>
        <div v-if="messageContext.link && messageContext.link.txt === '联系客服'" class="contact">
          <button class="contact-btn" open-type="contact" bindcontact="handleContact">
            在线客服
          </button>
          <span class="text">联系客服</span>
        </div>
        <span
          v-if="messageContext.link && messageContext.link.txt === '去缴费'"
          class="text"
          @click="onLink"
        >
          {{ messageContext.link.txt }}
        </span>
      </div>
    </div>
    <!-- 自定义消息2 -->
    <div v-else-if="customTxt2" class="time-item">
      <div class="content">
        <span class="default-text">{{ messageContext.text }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { TIM_TYPE } from '@/timpackage/utils/timInit'
import { mapMutations } from 'vuex'
export default {
  name: 'imRevoke',
  props: {
    message: {
      type: Object,
      default() {
        return {
          payload: {}
        }
      }
    }
  },
  data() {
    return {}
  },
  computed: {
    isMe() {
      return this.message.flow === 'out'
    },
    revoke() {
      // 撤回消息
      return this.message.isRevoked
    },
    del() {
      // 删除消息
      return this.message.isDeleted
    },
    showReeditBtn() {
      if (!this.isMe) {
        return
      }
      // 显示重新编辑按钮, 5分钟内撤销的消息可删除
      const time = new Date().getTime()
      const disTime = Math.floor(time / 1000) - this.message.time
      return this.message.type === TIM_TYPE.MSG_TEXT && disTime < 300
    },
    customTxt2() {
      // 自定义文本消息
      let { data } = this.message.payload
      try {
        data = JSON.parse(data)
      } catch (e) {
        // console.log(e)
      }
      data = data || {}
      if (['98', '100'].includes(String(data.type))) {
        return data.content.text
      }
      return false
    },
    customTxt() {
      // 自定义文本消息
      let { data } = this.message.payload
      try {
        data = JSON.parse(data)
      } catch (e) {
        // console.log(e)
      }
      data = data || {}
      if (data.type === 99 || data.type === '99') {
        return data.content.text
      }
      return false
    },
    messageContext() {
      let { data } = this.message.payload
      try {
        data = JSON.parse(data)
      } catch (e) {
        // console.log(e)
      }
      data = data || {}
      return data.content
    }
  },
  created() {
    // console.log(this.message)
  },
  methods: {
    ...mapMutations('IM', ['SET_REEDIT']),
    onEditor() {
      const {
        payload: { text }
      } = this.message
      this.SET_REEDIT(text)
    },
    onLink() {
      // typeof toLink === 'function' && toLink(this.messageContext)
    }
  }
}
</script>

<style lang="scss" scoped>
.time {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0.426667rem 0;
  .time-item {
    display: inline-block;
    padding: 0.213333rem 0.426667rem;
    background: #eeeeee;
    font-size: 0.512rem;
    line-height: 0.512rem;
    border-radius: 0.469333rem;
    font-weight: 400;
    color: #888888;

    .content {
      font-size: 0.512rem;
      line-height: 0.512rem;
      font-weight: 400;
    }
  }

  .text {
    font-size: 0.512rem;
    line-height: 0.512rem;
    padding-left: 0.213333rem;
    font-weight: 400;
    color: #0089ff;
  }

  .default-text {
    @extend .text;
    color: #888888;
  }

  .contact {
    position: relative;
    display: inline-block;
    vertical-align: middle;
    overflow: hidden;
  }

  .contact-btn {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    z-index: 1;
    opacity: 0;
    overflow: hidden;
  }
}
</style>
